import type { AppPaneName, HeaderPaneName } from 'owa-app-pane-group-types';
import { onCloseAppPane, onCloseHeaderPane } from 'owa-app-pane-group-actions';
import { isCapabilityEnabled } from 'owa-capabilities';
import { newHeaderCapability } from 'owa-capabilities-definitions/lib/newHeaderCapability';
import { closeFlexPane } from 'owa-suite-header-apis/lib/flexpanes/utils/closeFlexPane';
import isAppPane from '../utils/isAppPane';
import isHeaderPane from '../utils/isHeaderPane';

export default function closeFlexPaneHelper(
    suitePaneName: string,
    paneName?: AppPaneName | HeaderPaneName,
    targetWindow?: Window
): void {
    if (!paneName || !isCapabilityEnabled(newHeaderCapability)) {
        closeFlexPane(suitePaneName);
        return;
    }

    if (isAppPane(paneName)) {
        onCloseAppPane(paneName, targetWindow);
    } else if (isHeaderPane(paneName)) {
        onCloseHeaderPane(paneName, targetWindow);
    } else {
        closeFlexPane(suitePaneName);
    }
}
